import React from 'react'
import type { ProductTooltipPopOverProviderProps } from './Context'
import { ProductTooltipPopOverProvider } from './Context'
import { Layout } from './Layout'

export const ProductTooltipPopOver = ({ productId, children, ...rest }: ProductTooltipPopOverProviderProps) => {
  return (
    <ProductTooltipPopOverProvider {...{ productId, ...rest }}>
      <Layout>{children}</Layout>
    </ProductTooltipPopOverProvider>
  )
}
